import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ILoggedInUserViewModel } from '../model/common.model';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  public currentActivePage: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public refreshRolesSubject$: BehaviorSubject<ILoggedInUserViewModel> = new BehaviorSubject<ILoggedInUserViewModel>(null);
  public refreshRolesAction = this.refreshRolesSubject$.asObservable();

  constructor() {}
}
